import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/api';

export function ShareRedirectPage() {
  const { shortId } = useParams<{ shortId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!shortId) {
      navigate('/', { replace: true });
      return;
    }

    fetch(apiUrl(`/api/share/${shortId}`))
      .then(res => res.text())
      .then(html => {
        const match = html.match(/\/campaigns\/([a-f0-9-]+)/);
        if (match) {
          navigate(`/campaigns/${match[1]}`, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      })
      .catch(() => {
        navigate('/', { replace: true });
      });
  }, [shortId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="relative w-12 h-12 mx-auto">
          <div className="absolute inset-0 rounded-full border-4 border-indigo-100"></div>
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-indigo-600 animate-spin"></div>
        </div>
        <div>
          <img src="/isotipo.png" alt="DonaApp" className="h-8 w-8 mx-auto mb-2 opacity-80" />
          <p className="text-sm text-gray-600 font-medium">Cargando campaña...</p>
          <p className="text-xs text-gray-400 mt-1">Serás redirigido en un momento</p>
        </div>
      </div>
    </div>
  );
}
